import {
    DEFINICIONESIF_LOADED,
    DEFINICIONIF_CHANGED,
} from './actions'



let initialState = {
    definicionesif: [],
}

export const definicionesif = (state = initialState, action) => {
    switch (action.type) {
        case DEFINICIONESIF_LOADED:
            return loadDefinicionesif(state, action.definicionesif);
        case DEFINICIONIF_CHANGED:
            return changeDefinicionif(state, action.ifid, action.definicionif);
        default:
            return state;
    }
}

const changeDefinicionif = (state, ifid, newDefinicionif) => {
    let newDefinicionesif= {...state.definicionesif};
    newDefinicionesif[ifid]= newDefinicionif;
    return { ...state, definicionesif: newDefinicionesif};
}

const loadDefinicionesif = (state, newDefinicionesif) => {
    let newDefiniconesifTransformadas= {};
    newDefinicionesif.forEach( (newDefinicionif) => {
        let ifid= newDefinicionif.ifid;
        let newDefinicionifTransformada= {
            codigo: newDefinicionif.codigo,
            alto: newDefinicionif.alto,
            columns: JSON.parse(newDefinicionif.columns),
            ifid: ifid
        }
        newDefiniconesifTransformadas[ifid]= newDefinicionifTransformada;
    })
    return { ...state, definicionesif: newDefiniconesifTransformadas };
}
